import { FormTemplate } from "components/modal/templates";
import ContactInfo from "components/shared/contactInfo";
import { getCustomNumberConfig, serializeReq } from "components/shared/form";
import { featureModuleTypesEnum } from "helpers/enums";
import { checkMechanic } from "helpers/mechanics";
import { trailerNumber } from "helpers/validators";
import { FuelTanks } from "helpers/vehicles/partials";
import { prepareVehicleOwnershipData } from "helpers/vehicles/ownership";
import React from "react";
import { getByPhoneNumber } from "sources/books/mechanics";
import { apply } from "sources/books/trailers";
import { config, initialState } from "../formConfig";
import Markup from "./markup";

class CreateTrailerModal extends FormTemplate {
    getValidationConfig = (state) => {
        return {
            ...this.props.config,
            number: getCustomNumberConfig({
                number: this.props.config.number,
                useCustomNumber: !!state.useCustomNumber,
                numberValidator: trailerNumber,
            }),
        };
    };

    componentDidMount() {
        const initial = this.props.initialState ? this.props.initialState : {};
        if (
            this.props.profile.availableFeatureModules.includes(featureModuleTypesEnum.RefuelingPlanning) &&
            !this.props.refuelingSettings.hideRefuelingPlanning
        ) {
            this.setState({
                isLoading: false,
                isValid: true,
                ...initial,
                isInRefuelingSyncList: this.props.refuelingSettings.addTrailerToRefuelingSyncByDefault,
            });
        } else {
            this.setState({ isLoading: false, isValid: true, ...initial });
        }
    }

    sendRequest = (stateData) => {
        const { useCustomNumber, ...data } = stateData;
        return apply(data);
    };

    setCustomNumberMode = ({ value }) => {
        const number = value ? this.state.number : "";
        const nextState = { ...this.state, number, useCustomNumber: value };
        const isValid = this.isValidForm(nextState);
        this.setState({ number, useCustomNumber: value, ...(isValid ? { isValid: true } : {}) });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const { isLoading, ...state } = this.state;
        if (!isLoading) {
            if (this.isValidForm(state)) {
                this.setState({ isLoading: true, isValid: true });
                checkMechanic(state);
                return this.sendRequest(serializeReq(prepareVehicleOwnershipData(state))).then((res) => {
                    if (res) {
                        this.props.mergeParams?.();
                        this.props.onSuccess?.(res);
                        this.close(res);
                    } else {
                        this.setState({ isLoading: false, isValid: false });
                    }
                });
            }
            this.setState({ isValid: false });
        }
    };

    renderBodyInner = () => {
        const { config, profile, refuelingSettings } = this.props;
        return (
            <Markup
                {...config}
                data={this.state}
                setValue={this.setValue}
                setCustomNumberMode={this.setCustomNumberMode}
                renderCheckbox={this.renderCheckbox}
                availableFeatureModules={profile.availableFeatureModules}
                organizationName={profile.organizationName}
                renderField={this.renderField}
                renderSelect={this.renderSelect}
                renderMechanic={this.renderMechanic}
                renderFuelTanks={this.renderFuelTanks}
                refuelingSettings={refuelingSettings}
            />
        );
    };

    renderFuelTanks = () => {
        const { modal, config, canEditBooks } = this.props;
        const props = {
            canEditBooks,
            modal,
            config: config.fuelTanks,
            fuelTanks: this.state.fuelTanks,
            setValue: this.setValue,
            createAction: true,
        };

        return <FuelTanks {...props} />;
    };

    renderMechanic = () => {
        const props = {
            renderField: this.renderField,
            contact: this.state.mechanic,
            setValue: this.setValue,
            config: this.props.config.mechanic,
            getContactInfo: getByPhoneNumber,
            fieldName: "mechanic",
        };
        return <ContactInfo {...props} />;
    };
}

const ConfiguredModal = (props) => (
    <CreateTrailerModal {...props} config={config} initialState={{ ...initialState, useCustomNumber: false }} />
);

export default ConfiguredModal;
